import { create_div } from 'js/utils';
import { load_swiper } from 'modules/carousel/load_swiper';

export default function init_carousels(){
    
    const init_swiper = ()=>{

        init_swiper_instances('.ff-swiper');

        init_swiper_instances('.custom_carousel_slides', {
            init_elements: true,
        })

        init_swiper_mobile();

        document.removeEventListener('swiper_ready', init_swiper)
    }

    document.addEventListener('swiper_ready', init_swiper)

    if( document.querySelector('.ff-swiper, .ff-swiper-mobile, .custom_carousel_slides') ) {
        load_swiper();
    }
}

function init_swiper_instances(selector, args = {} ){
    
    document.querySelectorAll(selector).forEach(el=>{

        setTimeout(()=>{

            if( args.init_elements ) {
                init_swiper_elements(el)
            }

            init_swiper_instance(el)

        }, 0);
    });

}

function init_swiper_instance(container, settings = null){

    if( typeof container.swiper !== 'undefined' ) return;

    if( settings === null ) {
        settings = container.dataset.swiper_settings;
    }

    settings = typeof settings !== 'undefined' ? JSON.parse(settings) : {}; 
    
    pagination_support(container, settings);
    navigation_support(container, settings);
    scrollbar_support(container, settings);

    settings = default_settings(settings);
    new Swiper(container, settings);

    container.dispatchEvent(new Event('swiper_init'));
}

function pagination_support(container, settings){

    let el;
    
    if( settings.pagination_el ) {
        el = document.querySelector(settings.pagination_el);
    }
    else {
        el = container.querySelector('.swiper-pagination');
    }
    
    if( !el ) return;

    if( typeof settings.pagination === 'undefined' ) {
        settings.pagination = {
            clickable: true,
        };
    }

    settings.pagination.el = el;
}

function navigation_support(container, settings){

    if( typeof settings.navigation === 'undefined' ) {
        settings.navigation = {};
    }
    
    let nav_prev;
    if( settings.nav_prev ) {
        nav_prev = document.querySelector(settings.nav_prev);
    }
    else {
        nav_prev = container.querySelector('.swiper-button-prev');
    }
    

    if( nav_prev ) {
        settings.navigation.prevEl = nav_prev;
    }

    let nav_next;
    if( settings.nav_next ) {
        nav_next = document.querySelector(settings.nav_next);
    }
    else {
        nav_next = container.querySelector('.swiper-button-next');
    }
    if( nav_next ) {
        settings.navigation.nextEl = nav_next;
    }
}

function scrollbar_support(container, settings) {

    const scrollbar = container.querySelector('.swiper-scrollbar');
    if( !scrollbar ) return;

    if( typeof settings.scrollbar === 'undefined' ) {
        settings.scrollbar = {
            draggable: true,
        };
    }
    
    settings.scrollbar.el = scrollbar;
}

function default_settings(settings){

    settings.speed = settings.speed ?? 700;

    if( typeof settings.autoplay !== 'undefined' ) {
        settings.autoplay.disableOnInteraction = settings.autoplay.disableOnInteraction ?? false;
    }
    
    return settings;
}

function init_swiper_elements(el){

    if( el.swiper_elements_init ) return;
    el.swiper_elements_init = 1;
    
    const slides = [];
    for( const slide of el.children ) {
        slide.classList.add('swiper-slide')
        slides.push(slide);
    }

    const wrapper = create_div('swiper-wrapper')
    el.prepend(wrapper);
    
    slides.forEach(slide=>{
        wrapper.append(slide)
    })

    return wrapper;
}

function init_swiper_mobile(){

    let loaded = false;

    const init = ()=>{
        
        if( screen.width >= 768 ) return;
        if( loaded ) return;
        loaded = true;
        
        import('classes/Swiper_Mobile').then((res)=>{
            const e = new Event('swiper_mobile_ready');
            e.Swiper_Mobile = res.default;
            document.dispatchEvent(e);
        })

        window.removeEventListener('resize', init);
    }
    
    window.addEventListener('resize', init);
    init();
}